/**
 * @description Regex to test for playwright user agents
 */
export const playwrightUserAgent = /Playwright/i;
